import React from 'react';

import {
  Card, CardBody,
  Col, Container, Progress,
  Row,
} from 'reactstrap';


import Loader from 'react-loader-spinner';
import Page from '../../../components/Layout/Page';
import DataUploader from '../../../components/elements/DataUploader';
import { uploadCsvSteps, UploadCsvStepsNames } from '../../../shared/constants/ConstsProgressSteps';

import sampleSurveyResult from '../../../assets/img/reporting/sample_survey_result.png';
import styled, { css } from 'styled-components';
import { check_if_task_is_done_nps } from '../../../api/mlRequests';
import PayPal from '../../../shared/components/payments/paypal';

const UploadStates = {
  SIGNUP: 'SIGNUP',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  UPLOADING_DATA: 'UPLOADING_DATA',
  PROCESSING_DATA: 'PROCESSING_DATA',
};

const FeatureImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 15px; // Reduced space
  max-width: 700px;
  min-width: 700px; // Wider for the middle image
  opacity: 0.6;
`;
const StyledCardBody = styled(CardBody)`
  padding: 5px; /* Example padding */
  text-align: center; /* Centers text */
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers content horizontally */
  justify-content: center; /* Centers content vertically */
`;

const StyledCard = styled(Card)`
  margin: 20px; /* Example padding */

`;
const UploadInstructions = styled.div`
  text-align: left;
  margin-top: 20px;
  list-style-type: none;
  font-size: 14px;
  padding-left: 30px;

  ul {
    list-style-type: none; /* Removes bullets */
    padding: 0; /* Indents list items */

    li {
      padding-top: 1px;
    }

  }

`;
const ProgressBarContainer = styled.div`
  width: 80%;
  border-radius: 5px;
  margin: auto;

  // Example of a media query for responsive design
  @media (max-width: 768px) {
    width: 75%;
  }
`;

class UploadSurveyDataPage extends React.Component {

  constructor(props) {
    super(props);

    this.gridWidth = 560;


    this.state = {
      activeState: UploadStates.EMAIL_VERIFIED,
      task_name: 'default',
      chosen_option: 'create_task',
      batchId: null, // Add batchId state
      isLoading: false, // Add loading state
      page: 0,
      progress: 0,
      showProgress: false,
      // eslint-disable-next-line no-undef
      initialSteps: [
        uploadCsvSteps[UploadCsvStepsNames.UPLOAD_CSV_FILE],
        uploadCsvSteps[UploadCsvStepsNames.GENERATING_REPORT],
      ],
    };
    this.state.initialSteps[0].isActive = true;
    this.onerror = this.onerror.bind(this);
    this.onload = this.onload.bind(this);
    this.onload_adddata = this.onload_adddata.bind(this);
    this.dataSend = this.dataSend.bind(this);
    this.updateTaskName = this.updateTaskName.bind(this);

    this.deleteNotInProgress = this.deleteNotInProgress.bind(this);

    this.onEmailVerified = this.onEmailVerified.bind(this);

    // this.progressBarRef = React.createRef();
  }

  simulateProgress = (duration, onComplete) => {
    let progress = 0;
    const intervalTime = 100; // update every 100 ms
    const step = intervalTime / duration;

    this.setState({ progress: 0, showProgress: true });

    this.progressInterval = setInterval(() => {
      progress += step;
      if (progress < 100) {
        this.setState({ progress });
      } else {
        clearInterval(this.progressInterval); // Clear the interval using the stored ID
        this.setState({ progress: 100 }, () => {
          setTimeout(() => {
            this.setState({ showProgress: false }, onComplete);
          }, 500); // wait a bit before hiding the progress bar
        });
      }
    }, intervalTime);
  };


  onEmailVerified() {
    this.setState({ activeState: UploadStates.EMAIL_VERIFIED });
    // this.progressBarRef.current.updateMultipleSteps([
    //   { key: UploadCsvStepsNames.SIGNUP, changes: { isComplete: true, isActive: false } },
    //   { key: UploadCsvStepsNames.UPLOAD_CSV_FILE, changes: { isComplete: false, isActive: true } },
    // ]);
  }

  componentWillUnmount() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }

  handleChange() {

  }


  onerror() {
    this.setState({
      name_error: 'Name already exists, please choose another name',
    });
  }

  onload() {
    this.refresh_tasks(false);

  }

  checkStatusPeriodically = (waitingId) => {
    const maxAttempts = 30;
    let attempts = 0;

    const intervalId = setInterval(() => {
      if (attempts < maxAttempts) {
        // Make a request to the status endpoint
        check_if_task_is_done_nps(waitingId, 'batch_id')
          .then((res) => {
            if (res.data.task_done) {
              clearInterval(intervalId);
              this.setState({ isLoading: false });
              // Handle successful completion here
              console.log('Processing completed!');
              this.props.history.push('/survey/reporting/AI?report_id=' + res.data.batch_id);
            }
          }).catch((error) => {

          this.setState({
            name_error: '',
            isLoading: false,
            activeState: UploadStates.EMAIL_VERIFIED,
          });
          console.error('Error fetching status:', error);
          clearInterval(intervalId);
        });
        attempts++;
      } else {
        clearInterval(intervalId);
        // Handling for when status check exceeds maxAttempts
        console.log('Status check exceeded max attempts');
      }
    }, 3000); // Check every 3 seconds
  };

  onload_adddata(result) {
    result = JSON.parse(result);
    console.log(result);
    // this.refresh_tasks(true)
    this.checkStatusPeriodically(result.waiting_id);
  }

  dataSend() {
    this.setState({
      name_error: '',
    });
  }

  updateTaskName(evt) {
    this.setState({
      task_name: evt.target.value,
    });
  }


  onSave = () => {
    this.schema_ref.current.save();
  };

  deleteNotInProgress() {

  }


  componentDidMount() {
    // this.refresh_tasks()

  }


  render() {




    return (
      <Page


      >
        {/*<ProgressBar ref={this.progressBarRef} initialSteps={this.state.initialSteps} />*/}


        <Col md={7}>
          <StyledCard>
            <StyledCardBody>
              <Row style={{ marginTop: '40px' }}>
                <Col>

                  <div className='container separator'>
                    <DataUploader
                      upload_url={'nps/upload'}
                      onload={this.onload_adddata}
                      onerror={this.onerror}
                      start_sending_data={() => {
                        this.setState({
                          name_error: '',
                          isLoading: true,
                          activeState: UploadStates.UPLOADING_DATA,
                        });


                        // Start simulating progress for 10 seconds upload + 60 seconds report generation
                        this.simulateProgress(550, () => {
                          // Callback function after the total 70 seconds
                          // Here you can handle what happens after the fake progress reaches 100%
                        });


                      }}

                    />
                    {this.state.showProgress && (
                      <ProgressBarContainer>
                        <Progress value={this.state.progress} />
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          Creating report, this may take around 30 seconds...
                        </div>
                      </ProgressBarContainer>

                    )}
                  </div>
                  <UploadInstructions>

                    <ul>
                      <li>Click the area above to select a CSV file from your device with survey results.
                      </li>
                      <li>Once selected, the file will
                        automatically begin uploading.
                      </li>
                      <li style={{ fontWeight: 600 }}>Upon upload, you will receive immediate analysis and actionable
                        insights on how to improve
                        your NPS score.
                      </li>

                    </ul>

                  </UploadInstructions>

                </Col>
              </Row>

              <Row style={{ marginTop: '30px' }}>

                <FeatureImage src={sampleSurveyResult} alt='Survey Result Sample' />
              </Row>
            </StyledCardBody>
          </StyledCard>
        </Col>


      </Page>
    );
  }
};

export default UploadSurveyDataPage;
